module.exports = "/images/nc.svg?dfbc2084830be0845f4c6f687f8c6aaa";